import gql from 'graphql-tag';

export const updateVisitorPasses = gql(/* GraphQL */ `
  mutation updateVisitorPasses($visitorPassIds: [UUID!]!, $channelId: String!, $eventStatus: String!) {
    updateVisitorPassesStatus(visitorPassIds: $visitorPassIds, channelId: $channelId, eventStatus: $eventStatus) {
      operationId
      results {
        visitorPassId
        success
        errorMessage
      }
    }
  }
`);